import React from 'react'
import { FaBook, FaFilePdf, FaInfoCircle, FaExternalLinkAlt } from 'react-icons/fa'
import { Card, Button } from 'react-bootstrap'
import './Manuals.css'

/** PDFs en `public/manuals/` — se sirven en `/manuals/<archivo>.pdf` */
const MANUALS = [
  {
    file: 'Academia.pdf',
    title: 'Academia',
    description: 'Manual de uso orientado al contexto de academia.',
  },
  {
    file: 'Coaching_Individual_y_Equipos.pdf',
    title: 'Coaching individual y equipos',
    description: 'Guía para coaching uno a uno y trabajo con equipos.',
  },
  {
    file: 'Cultura_y_Talento_Humano.pdf',
    title: 'Cultura y talento humano',
    description: 'Documentación sobre cultura organizacional y talento.',
  },
  {
    file: 'Empresas_Pymes_y_Startups.pdf',
    title: 'Empresas, pymes y startups',
    description: 'Manual aplicable a empresas, pymes y startups.',
  },
  {
    file: 'Equipos_de_Innovacion.pdf',
    title: 'Equipos de innovación',
    description: 'Uso del sistema en equipos enfocados en innovación.',
  },
  {
    file: 'Equipos_de_Liderazgo.pdf',
    title: 'Equipos de liderazgo',
    description: 'Material para equipos y liderazgo.',
  },
  {
    file: 'Marketing_y_Branding.pdf',
    title: 'Marketing y branding',
    description: 'Manual en contexto de marketing y marca.',
  },
  {
    file: 'Psicoterapia_Individual_y_Grupal.pdf',
    title: 'Psicoterapia individual y grupal',
    description: 'Documentación para terapia individual y grupal.',
  },
]

function manualPdfHref(fileName) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
  return `${base}/manuals/${encodeURIComponent(fileName)}`
}

export default function Manuals() {
  return (
    <div className="manuals-container">
      <div className="container">
        <div className="manuals-header">
          <div className="manuals-header-inner">
            <div className="manuals-header-icon">
              <FaBook />
            </div>
            <div className="manuals-header-text">
              <h1>Manuales de uso</h1>
              <p>
                Abrí cada manual en PDF en una nueva pestaña del navegador. Los archivos están disponibles
                para consulta e impresión cuando lo necesites.
              </p>
            </div>
          </div>
        </div>

        <Card className="manuals-intro-card">
          <Card.Body>
            <div className="manuals-info-banner">
              <FaInfoCircle className="manuals-info-icon" aria-hidden />
              <p>
                Cada documento abre en una nueva pestaña. Podés usar la opción de guardar o imprimir desde
                el visor de PDF de tu navegador.
              </p>
            </div>
          </Card.Body>
        </Card>

        <Card className="manuals-list-card">
          <Card.Body>
            <h2 className="manuals-section-title">
              <FaFilePdf className="me-2" aria-hidden />
              Documentos ({MANUALS.length})
            </h2>
            <p className="manuals-section-lead text-muted">
              Manuales disponibles en formato PDF.
            </p>

            <ul className="manuals-list list-unstyled mb-0">
              {MANUALS.map((manual) => {
                const href = manualPdfHref(manual.file)
                return (
                  <li key={manual.file} className="manuals-item">
                    <div className="manuals-item-main">
                      <FaFilePdf className="manuals-item-pdf-icon" aria-hidden />
                      <div className="manuals-item-text">
                        <h3 className="manuals-item-title">{manual.title}</h3>
                        <p className="manuals-item-desc">{manual.description}</p>
                        <span className="manuals-item-filename">{manual.file}</span>
                      </div>
                    </div>
                    <div className="manuals-item-actions">
                      <Button
                        as="a"
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="outline-primary"
                        className="manuals-btn-open"
                      >
                        <FaExternalLinkAlt className="me-2" aria-hidden />
                        Abrir PDF
                      </Button>
                    </div>
                  </li>
                )
              })}
            </ul>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}
